import React from 'react'
import { Box, Text } from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'

export default function RatingsFor(props) {
  const { ratingsFor }=props

  return (
    ratingsFor && ratingsFor.map(({ label, value }) => {
      const oValue = value * 20
      const gValue = 100 - value * 20
      const mapKey = `${label}-${value}`

      return (
        <React.Fragment key={mapKey}>
          <Box
            direction="row"
            margin={{
              bottom: 'small',
            }}
          >
            <Text size="xsmall" color="gray">
              {`${label}:`}
                    &nbsp;
            </Text>

            <Text size="xsmall" color="dark-2">
              {commaSeparetedValue(value, 1)}
              {' / '}
              {commaSeparetedValue(5, 1)}
            </Text>
          </Box>

          <Box
            direction="row"
            height="10px"
            margin={{
              bottom: 'medium',
            }}
          >
            <Box
              width={`${oValue}%`}
              background="orange"
              style={{
                borderRadius: oValue === 100 ? '8px 8px 8px 8px' : '8px 0px 0px 8px',
              }}
            />

            <Box
              width={`${gValue}%`}
              background="lightGray"
              style={{
                borderRadius: oValue === 0 ? '8px 8px 8px 8px' : '0px 8px 8px 0px',
              }}
            />
          </Box>
        </React.Fragment>
      )
    })
  )
}
